export function isValidTurnstileSiteKey(key) {
    if (!key || typeof key !== 'string') {
        return false;
    }

    const trimmed = key.trim();
    return /^(0x|1x)[A-Za-z0-9_-]+$/.test(trimmed);
}
